@if (anticipatedTime) {
  <div class="default-color" [ngStyle]="{ color: countdownColor }">
    @if (anticipatedTime) {
      <i
        class="pi pi-clock font-normal mr-2"
        [style.color]="showBlueIcon ? 'blue' : null"
        [pTooltip]="showBlueIcon ? 'AD Time Complete' : null"
      ></i>
    }
    <span>{{ anticipatedTime | elapsedTime }}</span>
  </div>
}

